import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClientsService } from 'src/app/services/clients.service';
import { PageEvent } from '@angular/material/paginator';
import { AddCardComponent } from '../../units/add-card/add-card.component';
import { MatDialog } from '@angular/material/dialog';
import { UnitBlockComponent } from '../../units/unit-block/unit-block.component';
import { UnitsService } from 'src/app/services/units.service';
import { MainService } from 'src/app/services/main.service';
import { InvtaionComponent } from '../../units/invtaion/invtaion.component';
import { QrInvtationComponent } from '../../units/qr-invtation/qr-invtation.component';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { AddNoteComponent } from '../../units/add-note/add-note.component';

@Component({
  selector: 'app-all-clients',
  templateUrl: './all-clients.component.html',
  styleUrls: ['./all-clients.component.css']
})
export class AllClientsComponent implements OnInit {

  all_clients :any = []
  curent_page = 0
  pageIndex = 0
  page_size = 40 
  pipe = new DatePipe('en-US');
  imageBase64:any
  imageBase641:any
  constructor(private route : Router ,
    public dialog: MatDialog,
    private _sanitizer: DomSanitizer,
    private mainService: MainService,
    private rest: UnitsService,
    private http: HttpClient,
     private clientServ : ClientsService){}

  ngOnInit(){
    this.http
    .get('/assets/images/fouka.jpg', { responseType: 'blob' })
    .subscribe((res: any) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        var base64data = reader.result;
        this.imageBase64 = base64data;
        this.allClients()

      };
      reader.readAsDataURL(res);
    });
    this.http
    .get('/assets/images/foukaone.jpg', { responseType: 'blob' })
    .subscribe((res: any) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        var base64data = reader.result;
        this.imageBase641 = base64data;
      };
      reader.readAsDataURL(res);
    });
    // this.clientSearch()
  }
  allClients(){
    this.cardObject.image1 = this.imageBase64;
    this.clientServ.allClietns(this.curent_page,this.page_size).subscribe((res:any) => {
      console.log(res)
      this.all_clients = res
      this.all_clients.forEach((element: any) => {
        if(element.images.length != 0){
          element.images.forEach((item:any) => {
            item.image = this._sanitizer.bypassSecurityTrustUrl(
              `data:image/png;base64,` + item.image
            )
            if(item.image_type == "personal_photo"){
              element.photo = item.image
            }
          });
        }else {
          element.images.push({
            image : "assets/images/avatar.png"
          })
        }
      });
    })
  }

  clientNameSearch = ""
  clientSearch(e:any){
    this.clientNameSearch = e.target.value
    this.clientServ.searchClient(this.clientNameSearch,this.curent_page,this.page_size).subscribe((res:any) => {
      console.log(res)
      this.all_clients = res
      this.all_clients.forEach((element: any) => {
        if(element.images.length != 0){
          element.images.forEach((item:any) => {
            item.image = this._sanitizer.bypassSecurityTrustUrl(
              `data:image/png;base64,` + item.image
            )
            if(item.image_type == "personal_photo"){
              element.photo = item.image
            }
          });
        }else {
          element.images.push({
            image : "assets/images/avatar.png"
          })
        }
      });
    })
  }
  Details(){
    this.route.navigateByUrl('pages/clients_payment')
  }
  clientLogs(){
    this.route.navigateByUrl('pages/clients_log')
  }

  handlePageEvent(e: PageEvent) {
    this.pageIndex = e.pageIndex
    this.curent_page = e.pageIndex + 1
    this.page_size = e.pageSize

    if(this.clientNameSearch != ''){
      this.clientServ.searchClient(this.clientNameSearch,this.pageIndex,this.page_size).subscribe((res:any) => {
        console.log(res)
        this.all_clients = res
      })
    }else {
      this.allClients()
    }

    console.log(e)
  }

  addCard(value: any) {
    const dialogRef = this.dialog.open(AddCardComponent, {
      width: '450px',
      data: { id: value.id }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.client_id = value.id;

        this.rest.addCard(result).subscribe((res: any) => {
          console.log(res);
          this.activeClient(value.id)
          this.mainService.SuccessToast('Card Added');
        });
      }
    });
  }
  activeClient(value:any){
    let data =  {
      id :value+"",
      activated : true,
    }
    this.clientServ.editClient(data).subscribe((res:any) => {
      console.log(res)
      this.mainService.SuccessToast("Client Activated")
      this.allClients()
    })
    console.log(data)
  }
  
  blockUnitGates(id: any) {
    let unitOrClientID: any;
    let unitOrCclientName: any;
    if (id != null) {
      unitOrClientID = id;
      unitOrCclientName = 'client';
    } else {
      unitOrClientID = "";
      unitOrCclientName = 'unit';
    }
    const dialogRef = this.dialog.open(UnitBlockComponent, {
      width: '400px',
      data: { id: unitOrClientID, name: unitOrCclientName }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (id != null) {
          let data = {
            gates: result,
            clients: [id]
          };
          if (result.balckList.length != 0) {
            data.gates = result.balckList;
            this.rest.balckListForClient(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('Client add in blackList Gates');
            });
          } else {
            data.gates = result.WhiteList;
            console.log(data);
            this.rest.whiteListForClient(data).subscribe((res: any) => {
              console.log(res);
              this.mainService.SuccessToast('Client add in whiteList Gates');
            });
          }
        } 
        console.log(result);
      }
    });
  }

  genrateInvtaion(value: any) {
    const dialogRef = this.dialog.open(InvtaionComponent, {
      width: '450px',
      data: {
        unitName: value.unit[0].name,
        clientName: value.name,
        unitId: value.unit[0].id
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.data.unit_id = value.unit[0].id;
        result.data.client_id = value.id;
        result.data.valid_from = this.pipe.transform(
          result.data.valid_from,
          'YYYY-MM-dd hh:mm:ss'
        );
        result.data.valid_to = this.pipe.transform(
          result.data.valid_to,
          'YYYY-MM-dd hh:mm:ss'
        );
        if (result.value == 'normal') {
           console.log(result.data)
          this.rest.clientInvtaion(result.data).subscribe(
            (res: any) => {
              let data :any = result
              data.qrName = res.qr_code
              data.unitName = value.unit[0].name
              data.inviter = value.name,
             this.openQr(data)
              console.log(res);
            },
            (err: any) => {
              this.mainService.erorrToast('somthing erorr');
            }
          );
        } else {
          console.log(result);
          this.rest.clientSmsInvite(result.data).subscribe(
            (res: any) => {
              console.log(res);
            },
            (err: any) => {
              this.mainService.erorrToast('somthing erorr');
            }
          );
        }
      }
    });
  }
  openQr(value:any){
    const dialogRef = this.dialog.open(QrInvtationComponent, {
      width: '450px',
      data: value
    });
  }

  cardObject = {
    name: '',
    unitName: '',
    validFrom: '',
    validTo: '',
    type: '',
    image: '',
    image1: 'assets/images/teamCard.jpg',
    villageName: '',
    status : false
  }; 
  dataPrint: any = [];
  print_card(data: any) {
    console.log(data)
    this.dataPrint = []
      this.cardObject.name = data.name;
      // this.cardObject.type = data.type.name + "'s" + ' ' + 'Card';
      if (data.type.name == 'Main Owner') {
        this.cardObject.type = 'owner' + "'s" + ' ' + 'Card';
      } else {
        this.cardObject.type = data.type.name + "'s" + ' ' + 'Card';
      }
      this.cardObject.validFrom = data.valid_from;
      this.cardObject.validTo = data.valid_to;
      if(data.unit.length != 0){
        this.cardObject.unitName = data.unit[0].name;
      }else {
        this.cardObject.unitName = ''
      }
      if(data.type.name == 'Main Owner' || data.type.name == 'Owner'){
        this.cardObject.image1 = this.imageBase641
        this.cardObject.status = true
      }else {
        this.cardObject.image1 = this.imageBase64
        this.cardObject.status = false
      }
      if (data.photo) {
        this.cardObject.image = data.photo;
      } else {
        this.cardObject.image = 'assets/images/avatar.png';
      }
      this.dataPrint.push(this.cardObject);
    
    setTimeout(() => {
      this.clientServ.printCardForClient(data.id).subscribe((res: any) => {
        console.log(res);
        this.mainService.SuccessToast('Printed success');
        this.allClients();
      });
      const button: any = document.getElementById('printButton');
      button.click();
    }, 200);
    
  }

  addNote(value: any, id: any) {
    let idOfClientOrUnit;
    idOfClientOrUnit = id;
    const dialogRef = this.dialog.open(AddNoteComponent, {
      width: '450px',
      data: { id: idOfClientOrUnit, name: value }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        result.client_id = id;
        (result.expiry_date = this.pipe.transform(new Date(), 'YYYY-MM-dd')),
          console.log(result);
        this.rest.addNoteForClient(result).subscribe((res: any) => {
          console.log(res);
          this.allClients()
          this.mainService.SuccessToast('Note Added for the client');
        });
      }
    });
  }

  editClient(value: any) {
    console.log(value)
     this.route.navigate(['pages/edit_client', value.unit[0].id, value.id]);
  }

  viewClient(value: any) {
    this.route.navigate(['pages/view_client', value.unit[0].id, value.id]);
  }

  blockClientTitle = 'Block';
  clientIdDeleted:any
  openBlockClient(title: any, item: any) {
    if (title == 'block') {
      this.blockClientTitle = 'Block';
    } else {
      this.blockClientTitle = 'Active';
    }
    this.clientIdDeleted = item.id;
    const button: any = document.getElementById('btn4');
    button.click();
  }

  blockClient() {
    let data = {
      id: this.clientIdDeleted,
      cancelled: true
    };
    if (this.blockClientTitle == 'Block') {
      data.cancelled = true;
    } else {
      data.cancelled = false;
    }
    this.clientServ.editClient(data).subscribe((res: any) => {
      console.log(res);
      if (this.blockClientTitle == 'Block') {
        this.mainService.SuccessToast('Client Blocked');
      } else {
        this.mainService.SuccessToast('Client Active');
      }
      this.allClients();
    });
  }

  // delete client

  openDeletClient(item: any) {
    this.clientIdDeleted = item.id;
    const button: any = document.getElementById('btn3');
    button.click();
  }

  DeleleClient() {
    this.rest.deleltClient(this.clientIdDeleted).subscribe((res: any) => {
      console.log(res);
      this.mainService.SuccessToast('Client deleted');
      this.allClients();
    });
  }

  goToUnit(name:any){
    this.route.navigate(['pages/unit_details', name])
  }

}
